import { ExportSection } from '../types';

export const reorderSectionColumns = (
  section: ExportSection,
  sourceColumnName: string,
  targetColumnName: string
): ExportSection => {
  const sourceIndex = section.columns.findIndex(
    (column) => column.name === sourceColumnName
  );
  const targetIndex = section.columns.findIndex(
    (column) => column.name === targetColumnName
  );

  if (sourceIndex === -1 || targetIndex === -1 || sourceIndex === targetIndex) {
    return section;
  }

  // Drag-and-drop reuses the same persisted column order as arrow movement.
  const columns = [...section.columns];
  const [movedColumn] = columns.splice(sourceIndex, 1);
  columns.splice(targetIndex, 0, movedColumn);

  return { ...section, columns };
}
